<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Greeting</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/greetings" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createGreeting" v-if="greeting">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="greeting.bannerMessage"
                                          label="Message"
                                          placeholder="Enter Greeting Message"
                                          v-validate="rules.bannerMessage"
                                          data-vv-name="bannerMessage"
                                          cus-name="bannerMessage"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-3">
                            <fg-input type="text"
                                      v-model="greeting.destinationURL"
                                      label="URL"
                                      placeholder="Enter URL (Optional)"
                                      data-vv-name="destinationURL"
                                      cus-name="destinationURL"
                                      >
                            </fg-input>
                          </div>
                          <div class="col-3" v-if="dateStatus.length">
                            <fg-select
                              v-model="isDateEnabled"
                              label="Enable Date"
                              :list="dateStatus"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-3" v-if="enableDate">
                            <label>Start Date</label>
                            <datetime v-model="startDate"
                                      input-class="form-control"
                                      placeholder="Choose a Date"
                                      type="datetime"
                                      :min-datetime="startDate"
                                      input-format="DD-MM-YYYY HH:mm"
                                      auto-continue>

                            </datetime>
                          </div>
                          <div class="col-3"  v-if="enableDate">
                            <label>End Date</label>
                            <datetime v-model="endDate"
                                      input-class="form-control"
                                      placeholder="Choose a Date"
                                      type="datetime"
                                      input-format="DD-MM-YYYY HH:mm"
                                      auto-continue>

                            </datetime>
                          </div>
                          <div class="col-6" v-if="corps.length">
                            <fg-select
                              v-model="greeting.corporationId"
                              label="Select Corporation"
                              :list="corps"
                              selectedKey="corporationId"
                           >
                            </fg-select>
                          </div>
                            <div class="col-4" v-if="status.length">
                              <fg-select
                                v-model="greeting.active"
                                label="Active"
                                v-validate="rules.active"
                                data-vv-name="active"
                                cus-name="active"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="status"
                                selectedKey="id"
                              >
                              </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Greeting
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateGreeting',
        created (){
    },
    data () {
      let dateTime = new Date();
        return {
            greeting: {
                bannerMessage: '',
                destinationURL: '',
                active: '1',
                start_date: '',
                end_date: '',
                corporationId: 0,
            },
            corps: [],
            startDate: dateTime.toISOString(),
            endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
            enableDate: false,
            isDateEnabled: 0,
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            dateStatus: [{id:"1", name:'Yes'}, {id:"0", name:'No'}],
            rules: {
              bannerMessage: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
      watch: {
          'isDateEnabled' (to, from) {
            if (this.isDateEnabled == 1) {
              this.enableDate = true
            } else {
              this.enableDate = false
            }
          }
      },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corps = res;
            console.log("this.corporations : ", this.corporations);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        createGreeting () {
          console.log('status flag', this.isDateEnabled)
          if (this.isDateEnabled == 1) {
            console.info('inside first condition')
            let startDate = new Date(this.startDate).getTime();
            let endDate = new Date(this.endDate).getTime();
            if (endDate < startDate) {
              this.showPopup('Error!', 'Greeting End Date must be greater then start Date.', 'error')
            } else {
              this.greeting.start_date =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
              this.greeting.end_date =  moment(endDate).format('MM/DD/YYYY H:mm:ss');
              console.log('greeting date', this.greeting)
              this.$validator.validateAll().then((result) => {
                if (result) {
                  this.$store.dispatch('ADD_GREETING', this.greeting)
                    .then((res) => {
                      console.log("ADD_TESTIMONIAL res : ", res);
                      if (res) this.showPopup('Success!', 'Greeting is successfully created', 'success', () => this.$router.push('/admin/greetings'))
                      else this.showPopup('Error!', 'Unable to process.', 'error')
                    })
                    .catch(err => {
                      this.showPopup('Error!', 'some thing happen wrong', 'error')
                      console.log("ADD_TESTIMONIAL API error : ", err);
                    })
                }
              })
            }
          } else {
            this.$validator.validateAll().then((result) => {
              if (result) {
                this.greeting.start_date =  null;
                this.greeting.end_date =  null;
                this.$store.dispatch('ADD_GREETING', this.greeting)
                  .then((res) => {
                    console.log("ADD_TESTIMONIAL res : ", res);
                    if (res) this.showPopup('Success!', 'Greeting is successfully created', 'success', () => this.$router.push('/admin/greetings'))
                    else this.showPopup('Error!', 'Unable to process.', 'error')
                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("ADD_TESTIMONIAL API error : ", err);
                  })
              }
            })
          }
//          let startDate = new Date(this.startDate).getTime();
//          let endDate = new Date(this.endDate).getTime();
//          if (endDate < startDate) {
//            this.showPopup('Error!', 'Greeting End Date must be greater then start Date.', 'error')
//          } else {
//            this.$validator.validateAll().then((result) => {
//              if (result) {
//                this.$store.dispatch('ADD_GREETING', this.greeting)
//                  .then((res) => {
//                    console.log("ADD_TESTIMONIAL res : ", res);
//                    if (res) this.showPopup('Success!', 'Greeting is successfully created', 'success', () => this.$router.push('/admin/greetings'))
//                    else this.showPopup('Error!', 'Unable to process.', 'error')
//                  })
//                  .catch(err => {
//                    this.showPopup('Error!', 'some thing happen wrong', 'error')
//                    console.log("ADD_TESTIMONIAL API error : ", err);
//                  })
//              }
//            })
//          }
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
      this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Greetings/CreateGreeting.vue